import BaseValidator from "./base_validator"

export default class ConfirmationValidator extends BaseValidator {
  validate() {
    let valid = true
    let errorMessage = ''

    const confirmation_field = document.getElementById(`${this.id}_confirmation`)
    if(confirmation_field == null || confirmation_field.value === ''){
      return { valid: valid, message: errorMessage }
    }

    if(this.value !== confirmation_field.value){
      valid = false
      errorMessage = 'no coincide'
    }
    return { valid: valid, message: errorMessage }
  }
}
